
// Default name components for fallback when database access fails
export const fallbackFirstNamePrefixes = [
  "Jolly", "Twinkle", "Sparkle", "Merry", "Jingle", "Tinsel", "Holly", "Mistletoe",
  "Frosty", "Glitter", "Sugar", "Candy", "Ginger", "Cinnamon", "Pepper", "Pudding"
];

export const fallbackFirstNameSuffixes = [
  "bell", "jingle", "whistle", "toe", "mint", "snap", "pop", "cake",
  "cookie", "sweet", "chime", "twinkle", "sparkle", "shine", "glow", "light"
];

export const fallbackLastNames = [
  "Sugarplum", "Peppermint", "Mistletoe", "Stocking", "Sleighbell", "Snowflake", "Gingerbread", "Cinnamon",
  "Evergreen", "Starlight", "Candycane", "Ornament", "Tinsel", "Bauble", "Eggnog", "Fruitcake"
];

// Cache refresh time in milliseconds (5 minutes)
export const CACHE_REFRESH_TIME = 300000;
